import { Rule } from '../types';

const MM_TO_IN = 25.4;
const CLEAR_WIDTH_MIN_IN = 870 / MM_TO_IN; // ~34.25"

export const ruleWidth: Rule = (submission) => {
  // CCQ 3.8.3.4 : largeur libre min 870 mm entre mains courantes
  // 36" = 914 mm brut. Après retrait des MC + barrotins (~25-50 mm de chaque côté),
  // la largeur libre tombe à ~865 mm — limite mais acceptable.
  // 48" = 1219 mm — largement suffisant.
  void CLEAR_WIDTH_MIN_IN; // referenced for documentation purposes
  if (submission.config.widthIn >= 48) return null;

  return {
    ruleId: 'width-clear-min',
    severity: 'info',
    humanMessage: `Largeur 36" (914 mm brut) — limite après MC/barrotins. Pour PMR aisée, 48" recommandé.`,
    suggestion: {
      type: 'switch-width',
      patch: { config: { ...submission.config, widthIn: 48 } },
    },
  };
};
